export const inboxList = [
  {
    title: "A. Move Out",
    description: "A. Move Out",
    emoji: "🚚",
    scheduleDate: "Jan 17",
    timing: "02:09PM",
    itemList: [
      {
        id: 1,
        title: "Evaluate and create tasks:",
        checkBox: false,
      },
      {
        id: 2,
        title: "Evaluate move out",
        checkBox: true,
      },
      {
        id: 3,
        title: "Make Ready",
        checkBox: true,
      },
      {
        id: 4,
        title: "Property Listing",
        checkBox: true,
      },
      {
        id: 5,
        title: "Tenant/owner follow up:",
        checkBox: false,
      },
      {
        id: 6,
        title: "Confirm notice",
        checkBox: true,
      },
      {
        id: 7,
        title: "Single Move Out",
        checkBox: true,
      },
      {
        id: 8,
        title: "Breaking Lease",
        checkBox: true,
      },
      {
        id: 9,
        title: "Move out Directions",
        checkBox: true,
      },
      {
        id: 10,
        title: "Owner requested non renewal",
        checkBox: true,
      },
      {
        id: 11,
        title: "move out day:",
        checkBox: false,
      },
      {
        id: 12,
        title: "Keys In",
        checkBox: true,
      },
      {
        id: 13,
        title: "Keys Missing",
        checkBox: true,
      },
      {
        id: 14,
        title: "Inspections:",
        checkBox: false,
      },
      {
        id: 15,
        title: "Property Inspection",
        checkBox: true,
      },
      {
        id: 16,
        title: "support staff inspection",
        checkBox: true,
      },
      {
        id: 17,
        title: "Ending process :",
        checkBox: false,
      },
      {
        id: 18,
        title: "Ending mgmt/selling",
        checkBox: true,
      },
      {
        id: 19,
        title: "Cancel move out",
        checkBox: true,
      },
      {
        id: 20,
        title: "FAQ Links",
        checkBox: true,
      },
    ],
  },
  {
    title: "B. Make Ready",
    description: "B. Make Ready",
    emoji: "🛠️",
    scheduleDate: "Jan 17",
    timing: "02:19PM",
    itemList: [
      {
        id: 1,
        title: "Evaluate and Notify owner:",
        checkBox: false,
      },
      {
        id: 2,
        title: "Evaluate status of property",
        checkBox: true,
      },
      {
        id: 3,
        title: "Send owner Make Ready Email",
        checkBox: true,
      },
      {
        id: 4,
        title: "Stingray Make Ready:",
        checkBox: false,
      },
      {
        id: 5,
        title: "Stingray Make Ready",
        checkBox: true,
      },
      {
        id: 6,
        title: "Owner Concerns:",
        checkBox: false,
      },
      {
        id: 7,
        title: "MAKE READY FUNDS-IMPORTANT",
        checkBox: true,
      },
      {
        id: 8,
        title: "Owner short on funds",
        checkBox: true,
      },
      {
        id: 9,
        title: "Owner Doing Make Ready",
        checkBox: true,
      },
      {
        id: 10,
        title: "Owner make ready inspection fee",
        checkBox: true,
      },
      {
        id: 11,
        title: "Utilities/Lawn:",
        checkBox: false,
      },
      {
        id: 12,
        title: "Utility Activation",
        checkBox: true,
      },
      {
        id: 13,
        title: "Lawn Care Start",
        checkBox: true,
      },
      {
        id: 14,
        title: "Work Completed",
        checkBox: true,
      },
      {
        id: 15,
        title: "Ending Process:",
        checkBox: false,
      },
      {
        id: 16,
        title: "ending mgmt / owner selling",
        checkBox: true,
      },
      {
        id: 17,
        title: "Cancel Make Ready",
        checkBox: true,
      },
      {
        id: 18,
        title: "FAQ",
        checkBox: true,
      },
    ],
  },
  {
    title: "C. SD Refund",
    description: "C. SD Refund",
    emoji: "💸",
    scheduleDate: "Jan 17",
    timing: "03:19PM",
    itemList: [
      {
        id: 1,
        title: "Evaluate Task:",
        checkBox: false,
      },
      {
        id: 2,
        title: "review invoices-MUST CHECK TO START COLLECTIONS",
        checkBox: true,
      },
      {
        id: 3,
        title: "review inspection",
        checkBox: true,
      },
      {
        id: 4,
        title: "Refund process:",
        checkBox: false,
      },
      {
        id: 5,
        title: "go through steps on appfolio move out page",
        checkBox: true,
      },
      {
        id: 6,
        title: "SD waiver refund process",
        checkBox: true,
      },
      {
        id: 7,
        title: "mail disposition",
        checkBox: true,
      },
      {
        id: 8,
        title: "Information:",
        checkBox: false,
      },
      {
        id: 9,
        title: "FAQ",
        checkBox: true,
      },
    ],
  },
  {
    title: "D. Property Listing",
    description: "D. Property Listing",
    emoji: "🏡",
    scheduleDate: "Jan 17",
    timing: "10:29PM",
    itemList: [
      {
        id: 1,
        title: "Beginning Stages:",
        checkBox: false,
      },
      {
        id: 2,
        title: "coming soon steps",
        checkBox: true,
      },
      {
        id: 3,
        title: "property info",
        checkBox: true,
      },
      {
        id: 4,
        title: "Prep for showings:",
        checkBox: false,
      },
      {
        id: 5,
        title: "Owner showing/interest reports",
        checkBox: true,
      },
      {
        id: 6,
        title: "Pro Photos",
        checkBox: true,
      },
      {
        id: 7,
        title: "Inspect property by PM",
        checkBox: true,
      },
      {
        id: 8,
        title: "* support staff to inspect",
        checkBox: true,
      },
      {
        id: 9,
        title: "*Ready to show- showing inspections start",
        checkBox: true,
      },
      {
        id: 10,
        title: "Add to mow list",
        checkBox: true,
      },
      {
        id: 11,
        title: "*place codebox",
        checkBox: true,
      },
      {
        id: 12,
        title: "Del City properties:",
        checkBox: false,
      },
      {
        id: 13,
        title: "Del City Process",
        checkBox: true,
      },
      {
        id: 14,
        title: "Del City Inspection follow up",
        checkBox: true,
      },
      {
        id: 15,
        title: "Listing Review:",
        checkBox: false,
      },
      {
        id: 16,
        title: "Zillow Verification",
        checkBox: true,
      },
      {
        id: 17,
        title: "Map Verification - Zillow",
        checkBox: true,
      },
      {
        id: 18,
        title: "*Ending mgmt/owner selling",
        checkBox: true,
      },
      {
        id: 19,
        title: "Information:",
        checkBox: false,
      },
      {
        id: 20,
        title: "FAQ",
        checkBox: true,
      },
    ],
  },
  {
    title: "E. Listing Follow up",
    description: "E. Listing Follow up",
    emoji: "✒️",
    scheduleDate: "Jan 17",
    timing: "11:29PM",
    itemList: [
      {
        id: 1,
        title: "Steps to do:",
        checkBox: false,
      },
      {
        id: 2,
        title: "Listing Follow Up",
        checkBox: true,
      },
      {
        id: 3,
        title: "Still for rent?/ over 60 days?",
        checkBox: true,
      },
      {
        id: 4,
        title: "Rented",
        checkBox: true,
      },
      {
        id: 5,
        title: "Cancel Scheduled reports",
        checkBox: true,
      },
      {
        id: 6,
        title: "Ending mgmt:",
        checkBox: false,
      },
      {
        id: 7,
        title: "Owner Selling/Ending Management",
        checkBox: true,
      },
    ],
  },
  {
    title: "F. Move In",
    description: "F. Move In",
    emoji: "📋",
    scheduleDate: "Jan 17",
    timing: "01:19AM",
    itemList: [
      {
        id: 1,
        title: "Information:",
        checkBox: false,
      },
      {
        id: 2,
        title: "application info",
        checkBox: true,
      },
      {
        id: 3,
        title: "Offer:",
        checkBox: false,
      },
      {
        id: 4,
        title: "Offer property/section 8 at bottom",
        checkBox: true,
      },
      {
        id: 5,
        title: "Take property off market? notify owner",
        checkBox: true,
      },
      {
        id: 6,
        title: "Inspections:",
        checkBox: false,
      },
      {
        id: 7,
        title: "PM to inspect property prior to move in",
        checkBox: true,
      },
      {
        id: 8,
        title: "Support staff to inspect",
        checkBox: true,
      },
      {
        id: 9,
        title: "Property Accepted:",
        checkBox: false,
      },
      {
        id: 10,
        title: "Cancel Showings",
        checkBox: true,
      },
      {
        id: 11,
        title: "set up tenant and send lease",
        checkBox: true,
      },
      {
        id: 12,
        title: "Send Welcome Email",
        checkBox: true,
      },
      {
        id: 13,
        title: "Move in Prep:",
        checkBox: false,
      },
      {
        id: 14,
        title: "*End Lawn Care- URGENT",
        checkBox: true,
      },
      {
        id: 15,
        title: "*End utilities - URGENT",
        checkBox: true,
      },
      {
        id: 16,
        title: "Verify prorated rent paid",
        checkBox: true,
      },
      {
        id: 17,
        title: "add tenant tags",
        checkBox: true,
      },
      {
        id: 18,
        title: "Send move in code",
        checkBox: true,
      },
      {
        id: 19,
        title: "After Move in:",
        checkBox: false,
      },
      {
        id: 20,
        title: "assign for codebox pick up",
        checkBox: true,
      },
      {
        id: 21,
        title: "Move in cancelled",
        checkBox: true,
      },
      {
        id: 22,
        title: "Complete move in",
        checkBox: true,
      },
      {
        id: 23,
        title: "Info:",
        checkBox: false,
      },
      {
        id: 23,
        title: "FAQ",
        checkBox: true,
      },
    ],
  },
  {
    title: "G. Work Order Follow up",
    description: "G. Work Order Follow up",
    emoji: "👷‍♀️",
    scheduleDate: "Jan 17",
    timing: "12:29PM",
    itemList: [
      {
        id: 1,
        title: "work order info",
        checkBox: true,
      },
      {
        id: 2,
        title: "Assign work order",
        checkBox: true,
      },
      {
        id: 3,
        title: "Urgent work order",
        checkBox: true,
      },
      {
        id: 4,
        title: "Estimate process",
        checkBox: true,
      },
      {
        id: 5,
        title: "Owner Approval needed",
        checkBox: true,
      },
      {
        id: 6,
        title: "City Citation",
        checkBox: true,
      },
      {
        id: 7,
        title: "Del City Inspection",
        checkBox: true,
      },
      {
        id: 8,
        title: "Section 8",
        checkBox: true,
      },
      {
        id: 9,
        title: "Cancel Work order",
        checkBox: true,
      },
      {
        id: 10,
        title: "Work order completed",
        checkBox: true,
      },
    ],
  },
  {
    title: "H. Lease Renewal",
    description: "H. Lease Renewal",
    emoji: "🏘️",
    scheduleDate: "Jan 17",
    timing: "02:29PM",
    itemList: [
      {
        id: 1,
        title: "Review property inspection completed by tenant",
        checkBox: true,
      },
      {
        id: 2,
        title: "Contact Property Owner",
        checkBox: true,
      },
      {
        id: 3,
        title: "No reply from owner",
        checkBox: true,
      },
      {
        id: 4,
        title: "Notify Tenant of process",
        checkBox: true,
      },
      {
        id: 5,
        title: "Owner Selling Property/no longer manage",
        checkBox: true,
      },
      {
        id: 6,
        title: "Send Renewal Offer",
        checkBox: true,
      },
      {
        id: 7,
        title: "Tenant Vacating",
        checkBox: true,
      },
      {
        id: 8,
        title: "Section 8 Renewal",
        checkBox: true,
      },
      {
        id: 9,
        title: "Renewal Follow Up",
        checkBox: true,
      },
      {
        id: 10,
        title: "Renewal Signed",
        checkBox: true,
      },
      {
        id: 11,
        title: "Month to Month Renewal",
        checkBox: true,
      },
      {
        id: 12,
        title: "No reply on offer",
        checkBox: true,
      },
      {
        id: 13,
        title: "Completed",
        checkBox: true,
      },
    ],
  },
  {
    title: "I. Pay / Quit",
    description: "I. Pay / Quit",
    emoji: "👨‍⚖️",
    scheduleDate: "Jan 17",
    timing: "10:29PM",
    itemList: [
      {
        id: 1,
        title: "Tenant info",
        checkBox: true,
      },
      {
        id: 2,
        title: "Send Tenant follow up text",
        checkBox: true,
      },
      {
        id: 3,
        title: "Verify tenant status",
        checkBox: true,
      },
      {
        id: 4,
        title: "mark tenant as evict",
        checkBox: true,
      },
      {
        id: 5,
        title: "Contact tenant about past due rent",
        checkBox: true,
      },
      {
        id: 6,
        title: "Payment Received",
        checkBox: true,
      },
      {
        id: 7,
        title: "File for eviction",
        checkBox: true,
      },
      {
        id: 8,
        title: "Hearing Won-creates move out checklist",
        checkBox: true,
      },
      {
        id: 9,
        title: "House Vacant",
        checkBox: true,
      },
      {
        id: 10,
        title: "Hearing Lost",
        checkBox: true,
      },
      {
        id: 11,
        title: "Awaiting Lockout",
        checkBox: true,
      },
      {
        id: 12,
        title: "Lockout not complete",
        checkBox: true,
      },
      {
        id: 13,
        title: "Eviction/Lockout Complete- URGENT",
        checkBox: true,
      },
      {
        id: 14,
        title: "Items left at home by tenant",
        checkBox: true,
      },
      {
        id: 15,
        title: "ending mgmt/owner selling",
        checkBox: true,
      },
      {
        id: 16,
        title: "Cancel eviction process",
        checkBox: true,
      },
    ],
  },
];


